import React, { Component } from "react";

export default class SalaryInput extends Component {
  render() {
    return (
      <div className="col-sm-10">
        <input
          type="number"
          id="basic_salary"
          className="form-control input-md"
          value={this.props.value}
          onChange={this.props.onChange}
          style={{
            border: this.props.isError && "1px solid red",
          }}
        />
      </div>
    );
  }
}
